import { default as GooglePayButtonReact } from '@google-pay/button-react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useGPayRequestParams } from '../../../hooks/payments/useGPayRequestParams'
import { setOpenBuyQrTyModal, setOpenPaymentModal } from '../../../redux/slices/modal'
import { payWithGoogle } from '../../../redux/thunks/qr'
import { isProdEnv } from '../../../utils/env'
import { handleGooglePaymentError } from '../../../utils/payment/google/error'

const GooglePayButton = () => {
  const gPayRequestParams = useGPayRequestParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleGooglePaymentSuccess = async (paymentData) => {
    console.log('load payment data', paymentData)
    const token = paymentData.paymentMethodData.tokenizationData.token
    // console.log({ token })
    await dispatch(payWithGoogle({ token }))
      .unwrap()
      .then((originalPromiseResult) => {
        dispatch(setOpenPaymentModal(false))
        dispatch(setOpenBuyQrTyModal(true))
        navigate('tickets')
      })
      .catch((rejectedValueOrSerializedError) => {})
  }

  return (
    <GooglePayButtonReact
      environment={isProdEnv ? 'PRODUCTION' : 'TEST'}
      // buttonLocale="uk"
      buttonColor="white"
      buttonType="plain"
      buttonSizeMode="fill"
      paymentRequest={gPayRequestParams}
      onLoadPaymentData={handleGooglePaymentSuccess}
      // onCancel={() => console.log('Cancelled')}
      onError={handleGooglePaymentError}
      className="payment_button google_pay_button"
    />
  )
}

export default GooglePayButton
